export const LOAD = 'mandateProductsModal/LOAD';
export const SAVE = 'mandateProductsModal/SAVE';